import { Add } from "@mui/icons-material";
import { styled, Tooltip, IconButton } from "@mui/material";
import { colors } from "../../../../../../../theme/muiColors";
import { Switch } from "@mui/material";

export const NotificationSwitch = styled(Switch)(() => ({
    width: 63,
    height: 34,
    padding: 7,
    "& .MuiSwitch-switchBase": {
        padding: 1,
        transform: "translateX(6px)",
        "&.Mui-checked": {
            color: "#fff",
            transform: "translateX(35px)",
            "& + .MuiSwitch-track": {
                backgroundColor: "#ff9800",
                opacity: 1,
                border: 0,
                "&::before": {
                    display: "block",
                },
                "&::after": {
                    display: "none",
                },
            },
        },
    },
    "& .MuiSwitch-thumb": {
        width: 16,
        height: 16,
        marginTop: 8,
        boxShadow: "none",
    },
    "& .MuiSwitch-track": {
        borderRadius: 20 / 2,
        opacity: 1,
        backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
        boxSizing: "border-box",

        "&::before, &::after": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: 12,
            fontWeight: "bold",
            color: "#fff",
        },
        "&::before": {
            content: '"ON"',
            left: 12,
            display: "none",
            color: "white",
        },
        "&::after": {
            content: '"OFF"',
            right: 12,
            color: colors.orange[500],
        },
    },
}));

const ADD_OPTION_TOOLTIP = "Add another option";
const ADD_OPTION_TOOLTIP_Z_INDEX = 9999999;

interface AddOptionIconButtonProps {
    onClick: () => void;
    ariaLabel: string;
    disabled?: boolean;
}

export const AddOptionIconButton = ({ onClick, ariaLabel, disabled }: AddOptionIconButtonProps) => {
    return (
        <Tooltip
            arrow
            title={ADD_OPTION_TOOLTIP}
            PopperProps={{
                sx: { zIndex: ADD_OPTION_TOOLTIP_Z_INDEX },
                modifiers: [{ name: "offset", options: { offset: [0, 8] } }],
            }}
        >
            <IconButton
                disabled={disabled}
                onClick={onClick}
                aria-label={ariaLabel}
                sx={{
                    bgcolor: colors.orange[300],
                    color: "var(--fx-surface-text, #0F172A)",
                    "&:hover": { bgcolor: colors.orange[400] },
                }}
                size="small"
            >
                <Add />
            </IconButton>
        </Tooltip>
    );
};
